'use client';

import { API_ROUTES, HTTP_METHODS, useApiMutation } from '@shared/api-utils';
import { useCallback } from 'react';
import type { CartResponse } from '../types';

type UseCheckoutFlowOptions = {
  playerId: string;
};

function useCheckoutFlow({ playerId }: UseCheckoutFlowOptions) {
  const submitUrl = API_ROUTES.CART.SUBMIT.replace(':playerId', playerId);

  const { mutateAsync: submitCartMutation } = useApiMutation<CartResponse, undefined>(submitUrl, HTTP_METHODS.POST);

  const submitCart = useCallback(async (): Promise<CartResponse> => {
    const result = await submitCartMutation(undefined);
    if (!result) {
      throw new Error('Failed to submit cart');
    }

    return result;
  }, [submitCartMutation]);

  return { submitCart };
}

export { useCheckoutFlow, type UseCheckoutFlowOptions };
